import { Popover, Checkbox, Upload, Spin, message } from "antd"
import { useCallback, useMemo, useState} from "react"
import styles from './index.module.scss'
import LazyLoad from '@view/compoents/LazyLoad';
import Utils from '@utils/utils'
import { PlusOutlined, LoadingOutlined } from '@ant-design/icons';
import { RESOURCE_TYPE } from '@utils/CONST'
import Iconfont from '@utils/Iconfont';
import UploadRequirements from "../UploadRequirements";

const SelectionItem = (props) => {
    const {
        // 素材是否是视频
        isVideo,
        // 普通素材
        record,
        // 多选
        multiple,
        // 选中
        actived,
        // 超出可选数量
        overflow,
        // 超出可选数量提示文案
        overflowTips,
        // 显示素材名
        showName,
        // 收藏资源是否禁用
        favorDisabled,
        // 工具组
        toolGroup,
        // 点击
        onClick,
        // 点击子项
        onMoreClick,
        resourceType
    } = props

    // 素材处理中
    const isProcess = useMemo(() => {
        return "maskStatus" in record.attr ? record.attr?.maskStatus == "processing" : false
    }, [record])
    // 素材处理完成
    const isSuccess = useMemo(() => {
        return "maskStatus" in record.attr ? record.attr?.maskStatus == "succeeded" : true
    }, [record])
    // 素材是否有子项
    const hasChild = useMemo(() => {
        return record.subList.length > 0
    }, [record])
    // 素材是否可选：素材处理中/超出可选数量
    const selectable = useMemo(() => {
        if (!isSuccess) return false
        if (overflow) return false
        return true
    }, [isSuccess, overflow])
    // 素材是否收藏
    const isFavorite = useMemo(() => {
        return record.isFavorite
    }, [record.isFavorite])
    // 是否是vip资源
    const isPrivate = useMemo(() => {
        return record.attr.private == 1
    }, [record])
    // 素材是否可删除
    const removeable = useMemo(() => {
        return record.isCustom
    }, [record])
    // 收藏/取消收藏
    const handleFavor = e => {
        e.stopPropagation()
        toolGroup?.onFavor?.()
    }
    // 删除
    const handleRemove = e => {
        e.stopPropagation()
        toolGroup?.onRemove?.()
    }

    // 子项操作
    const [popoverOpen, setPopoverOpen] = useState(false)
    // 子项选中项
    const activedPopoverName = useMemo(() => {
        if (actived) return record.name
    }, [actived, record.name])
    // 子项点击
    const handlePopoverClick = (e, item) => {
        e.stopPropagation()
        setPopoverOpen(false)
        onMoreClick(item, record)
    }
    const PopoverContent = (
        <div className={styles.PopoverContent}>
            {
                record.subList.map(item => (
                    <div
                        key={item.name}
                        className={`${styles.PopoverSelectionItem} ${item.name == activedPopoverName && styles.actived}`}
                        onClick={(e) => handlePopoverClick(e, item)}
                    >
                        <img src={Utils.getImgThumbnail(item.imageUrlWithVersion)} alt="" />
                    </div>
                ))
            }
        </div>
    )
    const handlePopoverTriggerClick = e => {
        e.stopPropagation()
    }

    const handleOverflowClick = () => {
        message.warning(overflowTips)
    }

    const formartTitle = useMemo(() => {
        if (isProcess) return "生成中..."
        else {
            const title = record?.attr?.title
            const arr = title?.split('-')
            return arr?.length > 0 ? arr[arr.length - 1] : title
        }
    }, [record, isProcess])

    const showHoverText = useMemo(() => {
        return (resourceType == RESOURCE_TYPE.GLASSES_TRYON || resourceType == RESOURCE_TYPE.SIM_TRYON) &&
            !record?.attr?.refMask
    }, [resourceType, record])


    return (
        <div className={`${styles.SelectionItem} ${actived && styles.actived}`} onClick={selectable ? () => onClick(record) : overflow ? handleOverflowClick : null}>
            <div className={`${styles.SelectionItemontent} ${overflow && styles.overflow}`}>
                {
                    isVideo ?
                        <LazyLoad.Video key={record?.imageUrlWithVersion} src={record?.imageUrlWithVersion} /> :
                        <LazyLoad.Image key={record?.imageUrlWithVersion} src={Utils.getImgThumbnail(record?.imageUrlWithVersion)} />
                }
            </div>
            {
                showHoverText && <div className={styles.SelectionItemMask}>
                    {resourceType == RESOURCE_TYPE.SIM_TRYON ? '编辑重绘区域' : '标记佩戴区域'}
                </div>
            }
            {
                showName &&
                !!formartTitle &&
                <div className={styles.ResourceName}>
                    <span>{formartTitle}</span>
                </div>
            } {
                isPrivate &&
                <i className={styles.PrivateIcon}></i>
            } {
                (multiple && actived) &&
                <Checkbox
                    className={styles.SelectionItemCheckbox}
                    checked={actived}
                />
            } {
                isProcess ?
                    <div className={styles.SpinWrap}><Spin indicator={<LoadingOutlined style={{ fontSize: 40 }} spin />} /></div> :
                    <div className={styles.TriggerWrap}>
                        {
                            favorDisabled ? "" :
                                isFavorite ?
                                    <div className={`${styles.TriggerItem} ${styles.favorited} ${styles.visible}`} onClick={handleFavor}><Iconfont type="icon-StarFilled" /></div> :
                                    <div className={styles.TriggerItem} onClick={handleFavor}><Iconfont type="icon-StarOutlined" /></div>
                        } {
                            hasChild &&
                            <Popover
                                placement="bottomLeft"
                                open={popoverOpen}
                                arrow={false}
                                styles={{ body: { padding: 0 } }}
                                trigger={"click"}
                                content={PopoverContent}
                                onOpenChange={value => setPopoverOpen(value)}
                            >
                                <div className={`${styles.TriggerItem} ${styles.visible}`} onClick={handlePopoverTriggerClick}><Iconfont type="icon-SwitcherOutlined" /></div>
                            </Popover>
                        } {
                            removeable && <div className={styles.TriggerItem} onClick={handleRemove}><Iconfont type="icon-DeleteOutlined" /></div>
                        }
                    </div>
            }
        </div>
    )
}

const SelectionItemUploader = (props) => {
    const {
        resourceType = RESOURCE_TYPE.TRYON_MODEL,
        commoditySceneMode,
        onUpdate,
        onUpload,
    } = props
    // 上传中
    const [loading, setLoading] = useState(false)
    // 上传总数量
    const [totalNum, setTotalNum] = useState(0)
    // 上传成功数量
    const [succNum, setSuccNum] = useState(0)
    // 上传失败数量
    const [errorNum, setErrorNum] = useState(0)
    // 上传多个
    const uploadMultiple = useMemo(() => {
        if (resourceType == RESOURCE_TYPE.MODEL_SCENE) return true
        if (resourceType == RESOURCE_TYPE.COMMODITY_SCENE) return false
        else return true
    }, [resourceType])

    const maxCount = useMemo(() => {
        return 20
    }, [resourceType])
    // 上传文件类型
    const uploadAccept = useMemo(() => {
        if (resourceType == RESOURCE_TYPE.VIDEO_MODEL) {
            return "video/mp4"
        } else {
            return "image/jpeg,image/png,image/webp,image/avif"
        }
    }, [resourceType])
    // 显示图片要求 // 鞋子上脚和AI模特的场景没有要求
    const showUploadRequire = useMemo(() => {
        return resourceType != RESOURCE_TYPE.TRYON_SHOES &&
            resourceType != RESOURCE_TYPE.MODEL_SCENE &&
            resourceType != RESOURCE_TYPE.COMMODITY_SCENE &&
            resourceType != RESOURCE_TYPE.TRYON_SCENE &&
            resourceType != RESOURCE_TYPE.GLASSES_TRYON
    }, [resourceType])

    // 上传文件
    const uploadDebounce = useCallback(_.debounce(async (file, fileList) => {
        // 需要登录
        const status = Utils.checkLoginStatus(() => uploadDebounce(file, fileList))
        if (!status) return
        if (maxCount && fileList.length > maxCount) {
            message.warning(`最多上传${maxCount}张图片，已自动忽略超出部分`)
            fileList = fileList.slice(0, maxCount)
        }
        setLoading(true)
        let totalNum = fileList.length
        setTotalNum(totalNum)
        let succNum = 0
        setSuccNum(succNum)
        let errNum = 0
        setErrorNum(errNum)
        for (let file of fileList) {
            try {
                const res = await onUpload(file, resourceType, commoditySceneMode)
                if (!res) continue
                succNum++
                setSuccNum(succNum)
            } catch (err) {
                errNum++
                setErrorNum(succNum)
                console.error(err)
                message.warning(err?.message)
                continue
            }
            onUpdate()
        }
        // 上传完成
        if (errNum == totalNum) { // 全部失败
            if (totalNum != 1) message.warning('上传失败，请重新上传符合要求的资源！是是是')
        } else if (errNum != 0) { // 部分失败
            message.info(`${errNum}张上传失败，请重新上传符合要求的资源`)
        } else if (succNum == totalNum) { // 全部成功
            message.success('上传成功')
        } else {
            // 全部取消，不做任何处理
        }
        setLoading(false)
    }, 100), [resourceType, commoditySceneMode, onUpdate])
    // 上传文件
    const beforeUpload = async (file, fileList) => {
        if (loading) return
        uploadDebounce(file, fileList)
        return false
    }
    // 上传文件
    const handleDrop = async (e) => {
        if (loading) return
        if ("getFilesAndDirectories" in e.dataTransfer) {
            const filesAndDirs = await e.dataTransfer.getFilesAndDirectories()
            const fileList = await Utils.getFilesFromDirs(filesAndDirs, "/")
            console.log('===handleDrop===')
            uploadDebounce(fileList[0], fileList)
            return false
        }
    }

    const title = useMemo(() => {
        console.log('resourceType', resourceType)
        const triggerText = resourceType == RESOURCE_TYPE.TRYON_MODEL ? "上传参考图" :
            resourceType == RESOURCE_TYPE.POSE_TRYON ? "上传参考图" :
                resourceType == RESOURCE_TYPE.GLASSES_TRYON ? "上传参考图" :
                    resourceType == RESOURCE_TYPE.SIM_TRYON ? "上传参考图" :
                        resourceType == RESOURCE_TYPE.MODEL ? "上传模特" :
                            resourceType == RESOURCE_TYPE.MODEL_SCENE ? "上传背景" :
                                resourceType == RESOURCE_TYPE.TRYON_SCENE ? "上传背景" :
                                    resourceType == RESOURCE_TYPE.TRYON_SHOES ? "上传参考图" :
                                        resourceType == RESOURCE_TYPE.VIDEO_MODEL ? "上传动作" :
                                            resourceType == RESOURCE_TYPE.COMMODITY_SCENE ? "上传背景" :
                                                resourceType == RESOURCE_TYPE.COMMODITY_COLOR || resourceType == RESOURCE_TYPE.CLOTH_RECOLOR ? "上传颜色" :
                                                    resourceType == RESOURCE_TYPE.GRASS_PLANT ? "上传种草图" :
                                                        ""
        return triggerText
    }, [resourceType])

    return (
        <div className={styles.SelectionItem}>
            {
                resourceType == RESOURCE_TYPE.MODEL ?
                    <div className={`${styles.SelectionItemUploadTrigger} ${styles.ModalTrigger}`} onClick={() => onUpload(null, resourceType)} >
                        <div className={styles.SelectionItemUploadContent}>
                            <PlusOutlined />
                            <span>{title}</span>
                            {showUploadRequire &&
                                <Popover
                                    trigger="hover"
                                    placement="bottomLeft"
                                    arrow={false}
                                    content={<UploadRequirements resourceType={resourceType} commoditySceneMode={commoditySceneMode} />}
                                    onClick={e => e.stopPropagation()}
                                >
                                    <span className={styles.RequireTrigger}>{resourceType == RESOURCE_TYPE.VIDEO_MODEL ? "视频要求" : "图片要求"}</span>
                                </Popover>}
                        </div>
                    </div> :
                    <Upload.Dragger
                        className={styles.SelectionItemUploadTrigger}
                        multiple={uploadMultiple}
                        maxCount={30}
                        accept={uploadAccept}
                        showUploadList={false}
                        beforeUpload={beforeUpload}
                        onDrop={handleDrop}
                        disabled={loading}
                    >
                        <div className={styles.SelectionItemUploadContent}>
                            {loading ? <LoadingOutlined /> : <PlusOutlined />}
                            <span>{loading ? `已上传 ${succNum}/${totalNum}` : title}</span>
                            {showUploadRequire &&
                                <Popover
                                    trigger="hover"
                                    placement="bottomLeft"
                                    arrow={false}
                                    content={<UploadRequirements resourceType={resourceType} commoditySceneMode={commoditySceneMode} />}
                                    onClick={e => e.stopPropagation()}
                                >
                                    <span className={styles.RequireTrigger}>{resourceType == RESOURCE_TYPE.VIDEO_MODEL ? "视频要求" : "图片要求"}</span>
                                </Popover>}
                        </div>
                    </Upload.Dragger>
            }
        </div>
    )
}

SelectionItem.Uploader = SelectionItemUploader

export default SelectionItem